<mat-card class="container">
  <mat-card-content>
    <div class="links">
      <mat-card>
        <mat-card-content class="cardContentContainer">
          <div class="textContainer">
            <div>If you are a current team</div>
            <div>member, please go to</div>
            <div class="italic">WoW People Portal</div>
          </div>
          <a href="https://woolworths.my/salariedteamreview" mat-raised-button color="accent" class="roundedButton"
            target="_blank">
            <mat-icon iconPositionEnd>chevron_right</mat-icon>
            Go to portal</a>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-content class="cardContentContainer">
          <div class="textContainer">
            <div>If you are a former team</div>
            <div>member, please use the</div>
            <div class="italic">Former Team Contact Form</div>
          </div>
          <a id="former-team-button" href="https://teamspace.woolworths.com.au/external-queries" target="_blank"
            mat-raised-button color="accent" class="roundedButton">
            <mat-icon iconPositionEnd>chevron_right</mat-icon>
            Go to form
          </a>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-card-content>
</mat-card>